import ProductListFavorits from './ProductListFavorits'

export default ProductListFavorits
